module.exports = __webpack_public_path__ + "media/images/client-29-a0bd6a4e160848304499ffd4c6aa9aaf.png";